import React, { Component } from 'react';
import { withRouter, Link } from 'react-router';
import { connect } from 'react-redux';
import moment from 'moment';
import { Button } from 'react-bootstrap';
import Header from '../../../components/Header/Header';

import { activatePremium } from '../../ReportConfig/ReportActions';

import { PAGES, trackPageView, trackPriceQuoteRequest } from '../../../util/mixpanel';

// Import Style
import '../style.scss';

import teamDashboards from '../../../assets/img/team-dashboards.png';
import executiveDashboard from '../../../assets/img/executive-dashboard.png';
import forecastingDashboard from '../../../assets/img/forecasting-dashboard.png';

class TrialPage extends Component {
  onActivate(from) {
    this.props.activate(from);
  }

  trackPriceQuoteRequestClick() {
    trackPriceQuoteRequest();
  }

  render() {
    if (this.props.isLoading) return <div></div>;

    const location = this.props.router && this.props.router.location && this.props.router.location;
    const from = location && location.query && location.query.from;

    let trialExpired;
    let addonSubsEnded;

    const { user } = this.props;
    if (user && user.config) {
      trialExpired = moment(user.config.exportTrialEnd).diff(moment()) < 0;
      addonSubsEnded = user.config.exportDeactivationDate && !user.config.exportEnabled;
    }

    const message = trialExpired
      ? 'Your Premium trial has ended'
      : addonSubsEnded
        ? 'Your Premium subscription has ended'
        : 'Try Nave Premium for free';

    trackPageView(PAGES.PREMIUM);
    
    return (
      <React.Fragment>
        <Header showHome={true} />
        <div className='content'>
          
          <div className='content-free-trial'>
            <div className='content-free-trial-content'>
              <h1>{message}</h1>
              
              <ul>
                <li>Gain an end-to-end overview of the performance of your entire operations</li>
                <li>Get insights into whether your teams are improving or struggling</li>
                <li>Analyze trends across specific business areas, and more!</li>
              </ul>
            </div>
            
            <div className='content-free-trial-list'>
              <div className='content-free-trial-inner'>

                <div className='content-free-trial-item first'>
                  <h5 className='content-free-trial-title'>Nave Premium</h5>
                  <div className='content-free-trial-box'>
                    <h5>Nave Basic</h5>
                    <div class="img"><img src={teamDashboards} alt='Team Dashboards' /></div>
                    <h5>Team Dashboards</h5>
                  </div>
                </div>

                <div className='content-free-trial-second'>
                  <div className='content-free-trial-item'>
                    <div class="img"><img src={executiveDashboard} alt='Executive Dashboard' /></div>
                    <h5>Executive Dashboard</h5>
                  </div>

                  <div className='content-free-trial-item'>
                    <div className='content-free-trial-action'>
                      {trialExpired || addonSubsEnded ? (
                        <a href="mailto:hello@getnave.com"
                          className='btn btn-primary'
                          onClick={this.trackPriceQuoteRequestClick}
                          onAuxClick={this.trackPriceQuoteRequestClick}
                        >
                          Request Pricing Quote
                        </a>
                      ) : (
                        <Button type="button" variant='primary'  onClick={() => this.onActivate(from)}>
                          Start your Premium free trial
                        </Button>
                      )}
                      <Link to="/" className='btn btn-secondary'>
                        No, thanks!
                      </Link>
                    </div>
                    
                    <div class="img"><img src={forecastingDashboard} alt='Continuous Forecasting Dashboard' /></div>
                    <h5>Continuous Forecasting Dashboard</h5>
                  </div>
                </div>
              </div>
              <div className='content-free-trial-plan'>
                Your current plan
              </div>
              <p>*No automatic charges will occur unless you explicitly choose to activate your Premium Package!</p>
            </div>      
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    activate: from => dispatch(activatePremium(from))
  };
};

function mapStateToProps(state) {
  return {
    isLoading: state.auth.isLoading,
    user: state.auth.user,
    settings: state.report.settings
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TrialPage));
